//@ts-check
import { ClipPath, Defs, G, Path, Rect, Svg } from '@react-pdf/renderer';
import React from 'react';
import { Box } from '../../../pdf-design-system';
import qrcode from 'qrcode';

/**
 *
 * @param {qrcode.QRCodeToStringOptions & { url: string; logo?: 'unserwein' | 'bottlebooks'; color?: string; style?: import('@react-pdf/renderer').default.SVGProps["style"]; debug?: boolean; [x: string]: any }} props
 * @returns
 */
export default function QRCode({
  url,
  logo,
  margin,
  errorCorrectionLevel = logo ? 'Q' : 'M',
  style,
  color,
  ...rest
}) {
  const [qr, setQr] = React.useState({
    path: '',
    viewBox: '',
    svg: '',
  });
  if (qr.path) {
    if (logo === 'unserwein') {
      return (
        <UnserWeinCode
          viewBox={qr.viewBox}
          color={color}
          style={style}
          {...rest}
        >
          <Path stroke="#000" d={qr.path} />
        </UnserWeinCode>
      );
    }
    return (
      <Svg viewBox={qr.viewBox} style={style} {...rest}>
        <Path stroke="#000" d={qr.path} />
      </Svg>
    );
  }
  // We need to wait for the qr code to be generated. It's a fulfilled promise though, so we can immediately rerender.
  qrcode
    .toString(url, { margin, errorCorrectionLevel, type: 'svg' })
    .then((svg) => {
      const [, viewBox, path] =
        svg.match(/ viewBox="(.*)" shape.* d="(.*)"/) || [];
      if (!viewBox) {
        console.warn('no qrcode could be generated.');
        return;
      }
      return setQr({ viewBox, path, svg });
    });
  return <Box style={style} {...rest} />;
}

function UnserWeinCode({ viewBox, children, color = '#7a0033', ...rest }) {
  // To apply the logo and the clip path, we need to scale and translate the logo and the QR-Code multiple times.
  const targetViewBox = viewBox.split(' ').map(Number);
  const glassBox = [0, 0, 122.35, 122.35];
  const scaleX = glassBox[2] / targetViewBox[2];
  return (
    <Svg viewBox={glassBox.join(' ')} {...rest}>
      <Defs>
        <ClipPath id="glass">
          <Path d="M-4.5,-4.1H122.35V122.35H-4.5Z M70.355,74.011c-0.248-3.72-2.686-5.487-4.992-5.597c-0.812-0.039-1.621-0.121-2.402-0.229v-7.73c2.188-1.099,4.711-3.004,6.01-5.607c2.564-5.174-0.43-16.026-1.834-20.451l-1.008-3.176h-3.33h-5.133h-1.962h-5.132h-3.333l-1.004,3.179c-1.406,4.426-4.402,15.28-1.829,20.45c1.284,2.604,3.812,4.507,6.005,5.609v7.729c-0.785,0.106-1.588,0.19-2.407,0.232c-2.31,0.104-4.755,1.881-4.992,5.608l-0.311,4.842h4.854h8.148h1.962h8.15h4.869L70.355,74.011z" />
        </ClipPath>
      </Defs>
      <G transform="translate(4.5,4.1)">
        <G
          // @ts-ignore clipPath is working, but it's not in the typings.
          clipPath="url(#glass)"
          transform={`translate(-4.5,-4.1) scale(${scaleX})`}
        >
          {children}
        </G>
      </G>

      <Path
        transform="translate(4.5,4.1)"
        fill={color}
        d="M65.156,72.962c-2.518-0.119-4.84-0.586-6.742-0.943V58.721c0,0-0.012-1.454,1.07-1.752c1.559-0.429,4.398-2.101,5.414-4.145c2.027-4.084-2.096-17.048-2.096-17.048h-5.127h-1.963h-5.136c0,0-4.117,12.963-2.089,17.048c1.014,2.044,3.85,3.718,5.409,4.145c1.085,0.298,1.073,1.752,1.073,1.752v13.298c-1.902,0.357-4.227,0.824-6.743,0.943c-0.581,0.029-0.664,1.355-0.664,1.355h8.149h1.958h8.152C65.824,74.318,65.732,72.992,65.156,72.962z"
      />
    </Svg>
  );
}
